import $ from 'jquery';
import Mustache from 'mustache';
import { ExtranetTable } from './ExtranetTable';



export function customerMachineSearch(form) {

  //need to send language, get from html lang attr.
  let language = document.documentElement.lang;
  let formData = $(form).serialize();
  formData = formData + '&language=' + language;
  let formValues = $(form).serializeArray();
  //get elements to pass into subfunctions
  const formElems = $('.customer-machines');

  //get response
  $.ajax({
    type: 'get',
    url: '/stage-ajax/movax-data-search-request/',
    data: formData,
    cache: false,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    error: function (err) {
      console.log(err);
    },
    success: function (data) {
      if (!data.message) {
        //start showing data-table
        showDataTable(data, formElems, formValues);
      } else {
        //SHOW ERROR
        showErrors(data, formElems, formValues);
      }
    }
  });
}

/**
 *  Renders the machines data tables per years (Mustache), data is fetched via AJAX
 *
 * @param {object} data - search result in mustache formData, years{}, machineHeader{}
 * @param {object} formElems - (.customer-machines)
 * @param {object} formValues - form data values for rendering them back to user.
 */

function showDataTable(data, formElems, formValues = '') {

  const eTable = new ExtranetTable('table-extranet--big');

  const resultTemplate = formElems.find('.mustache-machine-data-result');
  const formErrorElem = formElems.find('.form-error');

  //clear previous error text (if one exist) and hide the element
  formErrorElem.hide();
  formErrorElem.text('');

  //render search values
  let searchValues = {};
  //show some proper text for values label
  const searchValuesLocalization = {
    year: 'Year',
    serialnumber: 'Serial Number',
    country: 'Country',
    distributorName: 'Distributor',
    endCustomer: 'End-customer'
  }

  //set mustache data with localization
  searchValues.searchValues = formValues.map(key => {
    if (key.name !== 'companyUuid') {
      return {
        name: searchValuesLocalization[key.name],
        value: key.value
      }
    }
  }).filter(Boolean);

  //check if we have search values and show searched texts
  const searchValuesElem = $('.form-searchvalues');
  let formCheck = searchValues.searchValues.filter(val => val.value !== '');
  if (formCheck.length > 0) {
    const mustacheSeachValuesTemplate = formElems.find('.mustache-machine-search-values');
    const searchvaluesContent = Mustache.render(mustacheSeachValuesTemplate.html(), searchValues);
    searchValuesElem.html(searchvaluesContent);
  } else {
    //clear search values element
    searchValuesElem.html('');
  }

  //Mustache - data: years{}, machineHeader{}
  const mustacheParams = {
    years: data.years,
    machineHeader: data.machineHeader
  };

  //render data tables
  const resultElement = formElems.find('.customer-machines--datatable');
  const resultContent = Mustache.render(resultTemplate.html(), mustacheParams);
  resultElement.html(resultContent);

  //table sort for new data
  // $('table.table-sort').DataTable({
  //   deferRender: true, //might optimze speed
  //   paging: false,
  //   searching: false,
  //   info: false,
  //   order: [],
  //   columnDefs: [ {
  //     targets: 'file',
  //     orderable: false
  //   }]
  // });

  //reinit table details function
  eTable.init();

}

/**
 * Shows the machine search error
 * @param {object} data - data.message, data.error from backend
 * @param {object[]} formElems form HTMLElements
 * @param {string} formValues form values
 */
function showErrors(data, formElems, formValues = '') {

  let formErrorElem = formElems.find('.form-error');
  let serialnumberInput = formElems.find('#serialnumber');
  let endcustomerInput = formElems.find('#endcustomer');

  //show error text
  formErrorElem.text(data.message);
  formErrorElem.show();

  //clear inputs
  serialnumberInput.val('');
  endcustomerInput.val('');
}

export default function init() {
  if ($('form.customer-machines__search-form').length > 0) {

    let form = $('form.customer-machines__search-form');
    let buttonReset = $('button[type="reset"]');
    buttonReset.prop('disabled', true); //by default prevent reset
    //prevent form submit
    form.on('submit', function (e) {
      e.preventDefault();
      customerMachineSearch(this);
      buttonReset.prop('disabled', false); //enable reset
    });
    //form reset button, get machines
    form.on('reset', function (event) {
      setTimeout(function () {
        // executes after the form has been reset
        buttonReset.prop('disabled', true); //disable reset
        $('.form-searchvalues').html(''); //clear search value messages
        customerMachineSearch(form); //get all data, form values are now empty
      }, 1);
    });

  }
}
